var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 9.06249V11.25H2.9375L9.38917 4.79833L7.20167 2.61083L0.75 9.06249ZM11.0808 3.10666C11.3083 2.87916 11.3083 2.51166 11.0808 2.28416L9.71583 0.91916C9.48833 0.69166 9.12083 0.69166 8.89333 0.91916L7.82583 1.98666L10.0133 4.17416L11.0808 3.10666Z",
    fill: "#989BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallEditIcon);
export default __webpack_public_path__ + "static/media/small_edit_icon.4e74709577e762953c9950d2445669a3.svg";
export { ForwardRef as ReactComponent };